import { StageEvent } from '../../message/index';
import ShortCutKey from '../../interaction/shortcutkey/index';
import Select from '../../interaction/select/index';

interface SelectCubesParams {
    cubes: Array<CubeNode>,
    eventFrom: EventFrom
}

function init(): void {
    // 面板选中事件监听
    StageEvent.on('selectCubes', (params: SelectCubesParams) => {
        // 这里需要阻止来源是画布的事件，否则会发生死循环
        if (params.eventFrom === 'stage') {
            return;
        }

        selectCubes(params.cubes);
    });
}

function selectCubes(cubes: Array<CubeNode>): void {
    let cubeIds: Array<string> = cubes.map((cube: CubeNode): string => {
        return cube.id;
    });

    Select.clear();
    Select.addGroup(cubeIds);
}

export default {
    init
};
